import {
    isInternational
} from './_checkForInternational';
import {
    startIntl
} from '../international/_intl';

const ajaxQueue = $({});

$.ajaxQueue = function(ajaxOpts) {
    var oldComplete = ajaxOpts.complete;
    ajaxQueue.queue(function(next) {
        ajaxOpts.complete = function() {
            if (oldComplete) oldComplete.apply(this, arguments);
            next();
        };
        $(document).ready(function() {
            $.ajax(ajaxOpts);
        });
    });
};

export const callAjaxEspots = () => {
    if ($("input[name='from'][value='ResetPassword']").length == 0) {
        $.each($('.espot.noncached'), function() {
            var espotDiv = $(this);
            $.ajaxQueue({
                cache: true,
                type: "GET",
                dataType: "json",
                url: "/webapp/wcs/stores/servlet/NonCacheESpot",
                data: "emsName=" + espotDiv.data('espotname') + "&maxNumDisp=1&storeId=301&catalogId=301&langId=-1",
                success: function(json) {
                    var successResp = json.JSON;
                    if (successResp != null) {
                        espotDiv.html(successResp.eSpotContent0 == null ? "" : successResp.eSpotContent0);
                        if (isInternational()) {
                            startIntl();
                        }
                    }
                    if (successResp.intlCacheCallVariable) Cookies.set("intlCacheCallVariable", successResp.intlCacheCallVariable);
                }
            });
        });
    }
};
